import React from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import {Container} from "reactstrap";
import SignInForm from "../components/Auth/SignInForm";
import VerificationForm from "../components/Auth/VerificationForm";
import PasswordResetForm from "../components/Auth/PasswordResetForm";
import {useUser} from "../contexts/AuthContext";
import Loading from "../components/Loading/Loading";

const AuthLayout: React.FC = () => {
  const {user, isInitialized} = useUser();

  // If not initialized, show loading
  if (!isInitialized) {
    return <Loading />;
  }

  // If user is already authenticated, redirect to upload
  if (user?.authenticated) {
    return <Navigate to="/upload" replace />;
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-background" />
      <Container fluid className="auth-container">
        <Routes>
          <Route path="/signup" element={<Navigate to="/shutdown" replace />} />
          <Route
            path="/signin"
            element={
              <Container fluid>
                <div className="row justify-content-center min-vh-100 align-items-center">
                  <div className="col-lg-5 col-md-7 col-sm-9 col-12">
                    <SignInForm />
                  </div>
                </div>
              </Container>
            }
          />
          <Route
            path="/verify"
            element={
              <Container fluid>
                <div className="row justify-content-center min-vh-100 align-items-center">
                  <div className="col-lg-5 col-md-7 col-sm-9 col-12">
                    <VerificationForm />
                  </div>
                </div>
              </Container>
            }
          />
          <Route
            path="/reset-password"
            element={
              <Container fluid>
                <div className="row justify-content-center min-vh-100 align-items-center">
                  <div className="col-lg-5 col-md-7 col-sm-9 col-12">
                    <PasswordResetForm />
                  </div>
                </div>
              </Container>
            }
          />
          <Route path="/" element={<Navigate to="/auth/signin" replace />} />
        </Routes>
      </Container>
    </div>
  );
};

export default AuthLayout;
